<template>
  <div>
    <div class="p-4 font-medium text-xs text-left leading-snug max-h-96 overflow-auto bg-charcoal-100 dark:bg-dark-950">
      
      <div class="bg-white dark:bg-dark-800 dark:text-dark-50 p-4 rounded-xl text-light-950 shadow space-y-3">
        <div>
          <p class="font-bold text-xl -mt-0.5">
            {{ $t('components.Event.review.received.title') }}
          </p>
          <p class="text-sm">
            {{ $t('components.Event.review.received.content') }}
          </p>
        </div>
        <div class="flex flex-wrap gap-1.5">
          <div class="relative inline-flex" v-for="user in usersStore.getItems(event.reviews.map(r => r.owner))">
            <UserPicture :user="user" size="md" is-hide-badges is-link />

            <div class="size-6 rounded-full flex items-center justify-center bg-tiger-100 absolute -bottom-0.5 -right-0.5">
              <ImageEmoji name="Clapping+Hands" class="size-4" />
            </div>
          </div>
        </div>

        <div class="flex items-center gap-1 flex-wrap">
          <TagBase color="royal-fill" size="base" class="pr-0.5" v-for="[tag, tagCount] in tags" :key="tag[0]">
            {{ $t(`components.Event.review.tags.${tag}`) }}

            <ChipRound size="xs" class="!bg-white !text-royal-600 ml-2 -my-0.5">{{ tagCount }}</ChipRound> 
          </TagBase>
        </div>
      </div>
    </div>

    <div class="bg-white border-t border-charcoal-200 dark:bg-dark-800 dark:border-dark-600 flex items-center space-x-2 p-2.5">
      <ButtonBase style-type="round" class="shrink-0" color="white" @click="() => emit('previous')">
        <IconBase name="cute/angle-right" class="rotate-180" :width="20" />
      </ButtonBase>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Event } from '@/classes'
import UsersStore from '@/store/users'
import { EVENT_REVIEW_TAGS } from '@/static/events'
import ImageEmoji from '@/components/Image/ImageEmoji.vue'

const props = withDefaults(defineProps<{
  event: Event
}>(), {

})

const { event } = toRefs(props)

const usersStore = UsersStore()

const emit = defineEmits<{
  (e: 'next'): void
  (e: 'previous'): void
  (e: 'reset'): void
}>()

const tags: Ref<Map<keyof typeof EVENT_REVIEW_TAGS, number>> = ref(new Map())

watch(event, () => {
  tags.value.clear()

  event.value.reviews.forEach(review => {
    review.tags.forEach(tag => {
      tags.value.set(tag, (tags.value.get(tag) ?? 0) + 1)
    })
  })
}, { immediate: true })

const isLoading = ref(false)
</script>